// extracted by mini-css-extract-plugin
export default {"container":"timerpage_container__mdOYm","timerPanel":"timerpage_timerPanel__rXhcw","tasksPanel":"timerpage_tasksPanel__RTym8"};